import type { Locale } from "@adpilot/shared";
import { api } from "./api";

/**
 * Persist the user's locale preference to the backend (PATCH /auth/me).
 * ADP-74: keeps the choice across devices and re-login; the local locale
 * store already covers same-device refresh. Best-effort — callers fire and
 * forget so a failed write never blocks the immediate UI language switch.
 */
export async function persistLocale(locale: Locale): Promise<void> {
  await api.patch("auth/me", { json: { locale } });
}
